import { DropDownMultiCheck } from "./DropDownMultiCheck";
import SaveFiltersModal from "./SaveFilters";
import { FilterSettings } from "./FilterSettings";
import { useAdvanceSearchContext } from "./AdvanceSearchContext";
import { FieldNames } from "./FieldNames";
import { useRef } from "react";
import Mobility from "./components/Mobility";

export default function SearchTab() {
  let mobilityRef = useRef();
  const {
    activeFilters,
    selectableFilters,
    onChangeSelectableFilters,
    showSaveFilters,
    setShowSaveFilters,
    executeSearch,
    t,
    onRemoveSelected,
    clear,
    onSaveFilters
  } = useAdvanceSearchContext();
  function ClearAll() {
    if (mobilityRef.current) mobilityRef.current.reset();
    clear();
  }
  return (
    <div className=" mb-5">
      <div className="row">
        <div className="col-1 align-bottom">
          <label className="form-label col-1">{t("Filters")}</label>
        </div>
        <div className="col-1 align-bottom">
          <FilterSettings />
        </div>
        <div className="col">
          <div className=" text-end">
            {activeFilters && activeFilters.length > 0 && (
              <button
                onClick={() => setShowSaveFilters(true)}
                className="app-button btn-second btn-md"
              >
                {t("Save")}
              </button>
            )}
          </div>
        </div>
      </div>
      <div>
        <DropDownMultiCheck
          dataList={selectableFilters}
          selecteds={activeFilters}
          setSelecteds={onChangeSelectableFilters}
          isIdStringType={true}
          onRemoveSelected={onRemoveSelected}
        />
      </div>
      <div className="text-end">
        <button onClick={ClearAll} className="app-button btn-second btn-md">
          {t("Clear")}
        </button>
        <button onClick={executeSearch} className="app-button btn-prime btn-md">
          {t("Search")}
        </button>
      </div>
      <div className="row">
        {activeFilters.map((filter, index) => (
          <>
            <div
              className=" col-3 mb-4"
              key={index}
              ref={filter.id === FieldNames.mobility ? mobilityRef : null}
            >
              {filter.id === FieldNames.mobility ? (
                <Mobility ref={mobilityRef} />
              ) : (
                filter.input()
              )}
            </div>
          </>
        ))}
      </div>
      <SaveFiltersModal
        show={showSaveFilters}
        selectFilters={activeFilters}
        close={() => setShowSaveFilters(false)}
        save={onSaveFilters}
      />
    </div>
  );
}
